import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import LoginComponent from "./loginComponent";
// import Grid from "@mui/material/Grid";
import AppUpdate from "../AppUpdate";
import PureJSComponentFactory from "./Pages/Factory/pureJSComponentFactory";
import { offlineLayoutInfo } from "../General/globals";
import PopupComponent from "./popupComponent";
import UnauthStartPage from "./unAuthStartPage";
import HttpService from "../Services/httpService";
import {
  unProcPath,
  authStorageKey,
  userDetailsStorageKey,
  userMenuStorageKey,
  apiRoot,
  authMethode,
  authBody,
  showCustomUnAuthPage,
  showCaptcha,
  jobId,
} from "../General/globals";
import { useLocation } from "react-router-dom";
import { findAllByDisplayValue } from "@testing-library/react";
import { ownStore } from "../AppOwnState/ownState";

class unAuthorizedComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unAuthUI: [],
    };

    this.pageFooter = new PureJSComponentFactory().scaffoldComponent(
      offlineLayoutInfo?.mainfooter
    );
    this.loginFooter = null;
    this.loginFooter = new PureJSComponentFactory().scaffoldComponent(
      offlineLayoutInfo?.loginfooter
    );
    this.loginSplitImage = new PureJSComponentFactory().scaffoldComponent(
      offlineLayoutInfo?.loginsplitimage
    );
  }

  async getStartPageUI() {
    const pathNameStr = this.props.location.pathname || "";
    const searchStr = this.props.location.search || "";

    const queryString = searchStr.includes("?") ? searchStr.split("?")[1] : "";

    const params = new URLSearchParams(queryString);
    const queryObject = {};

    const coreData = ownStore.getState("appCoreData");

    for (const [key, value] of params.entries()) {
      queryObject[key] = value;
    }

    const data = {
      info: {
        doctype: "page",
        docno: "unauthorised-page",
        urlparams: pathNameStr,
        queryparams: queryObject,
      },
    };

    const headers = {
      "Content-Type": "application/json",
    };
    const reqBody = new HttpService().getProcPostBodyString(
      jobId || authBody?.job_id,
      "PWA.LoadLayout",
      data,
      "single"
    );
    let startUI = await new HttpService().postServer(
      apiRoot,
      unProcPath,
      headers,
      reqBody
    );
    const parsedUI = JSON.parse(startUI?.[0]?.layoutinfo)?.layout;
    const startPageUI = new PureJSComponentFactory().scaffoldComponent(
      parsedUI
    );
    this.setState({ unAuthUI: startPageUI });
  }

  componentDidMount() {
    showCustomUnAuthPage && this.getStartPageUI();
  }

  render() {
    if (showCustomUnAuthPage) {
      return (
        <UnauthStartPage
          routerProps={this.props.routerProps}
          startUI={this.state.unAuthUI}
        />
      );
    } else {
      if (this.loginSplitImage) {
        return (
          <>
            <div className="login-container">
              {/* <div className="update-container"
                       style= {{ position: "absolute", top: "0", right: "0", height: "100vh" }}>

                 </div> */}
              <div container className="login-grid">
                <div className="left">
                  <AppUpdate />
                  <LoginComponent />
                </div>
                <div className="right">{this.loginSplitImage}</div>
                <div className="right">{this.pageFooter}</div>
              </div>
            </div>
            <PopupComponent />
          </>
        );
      } else {
        return (
          <>
            <div className="login-container">
              <div className="update-container">
                <AppUpdate />
              </div>
              <Grid container className="login-grid">
                <Grid item lg={4} sm={2}></Grid>
                <Grid item lg={4} sm={8}>
                  <LoginComponent />
                </Grid>
                <Grid item lg={4} sm={2}></Grid>
              </Grid>

              {this.pageFooter}
            </div>
            <PopupComponent />
          </>
        );
      }
    }
  }
}
export default unAuthorizedComponent;
